import ReportEdit from 'components/reports/ReportEdit';
import { BaseModel } from 'model/BaseModel';
import Pageable from 'model/page/Pageable';
import Estoque from 'model/suprimentos/Estoque';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Column, ColumnFilterElementTemplateOptions, ColumnSortEvent } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { DataTable, DataTableFilterMeta, DataTableStateEvent } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Row } from 'primereact/row';
import React, { useEffect, useState } from 'react';
import EstoqueService from 'service/suprimentos/EstoqueService';
import { converterData } from 'utils/convert';
import saveAs from 'file-saver';
import UsuarioLogadoService from 'service/usuario/UsuarioLogadoService';
import { SplitButton } from 'primereact/splitbutton';
import { useToastContext } from 'components/alert/ToastContext';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Dropdown } from 'primereact/dropdown';
import Deposito from 'model/suprimentos/Deposito';
import Produto from 'model/administracao/cadastro/produto/Produto';
import OrigemProduto from 'model/administracao/cadastro/produto/OrigemProduto';
import FamiliaProduto from 'model/administracao/cadastro/produto/FamiliaProduto';
import { IdMatchModeOptions, NumberMatchModeOptions, ProdutoFilterTemplate, TextMatchModeOptions, decimalFilterTemplate, filterApplyTemplate } from 'utils/filterUtils';
import { useFilter } from 'contexts/FilterContext';
import AjusteEstoqueModal from './AjusteEstoqueModal';
import ModalGerarRelatorioPrevisaoMateriaPrima from 'components/modal/suprimentos/ModalGerarRelatorioPrevisaoMateriaPrima';

interface Props {

}

const estoqueService = new EstoqueService();
const usuarioLogadoService = new UsuarioLogadoService();

function EstoqueConsulta(props: Props) {

    const defaultFilters = {
        origemProduto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        familiaProduto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        produto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        nomeProduto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        deposito: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        quantidade: {
            constraints: [
                {
                    value: 0,
                    matchMode: FilterMatchMode.GREATER_THAN,
                }
            ],
            operator: FilterOperator.AND
        },
        quantidadeEmprestada: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.GREATER_THAN,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    const filterContext = useFilter();
    const screen = "estoqueConsulta";

    const [pageable, setPageable] = useState(new Pageable(0, 10, "produto.id.codigo,desc", 0));
    const [filtrando, setFiltrando] = useState<boolean>(false);
    const [list, setList] = useState<BaseModel[]>([]);
    const [totalElements, setTotalElements] = useState<number>(0);
    const [visibleEditarRelatorio, setVisibleEditarRelatorio] = useState<boolean>(false);
    const [editaRelatorios, setEditaRelatorios] = useState<boolean>(false);
    const [ativaDesativaLote, setAtivaDesativaLote] = useState<boolean>(false);

    const [visibleConfiguracoes, setVisibleConfiguracoes] = useState<boolean>(false);
    const [esconderCodigos, setEsconderCodigos] = useState<boolean>(false);

    const [filters, setFilters] = useState<DataTableFilterMeta>(filterContext.filters[screen] ? filterContext.filters[screen] : defaultFilters);
    const [familias, setFamilias] = useState<FamiliaProduto[]>([]);
    const [origens, setOrigens] = useState<OrigemProduto[]>([]);
    const [produtos, setProdutos] = useState<Produto[]>([]);
    const [depositos, setDepositos] = useState<Deposito[]>([]);
    const [modalAjustar, setModalAjustar] = useState<{ visible: boolean, estoque: any, rowIndex: number }>({ visible: false, estoque: null, rowIndex: -1 })
    const [visibleGerarRelatorioPrevisaoMateriaPrima, setVisibleGerarRelatorioPrevisaoMateriaPrima] = useState<boolean>(false);


    const [estoqueSelecionado, setEstoqueSelecionado] = useState<Estoque | null>(null);
    const [ajustaEstoque, setAjustaEstoque] = useState<boolean>(false);

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    useEffect(() => {
        setEsconderCodigos(localStorage.getItem("esconderCodigos") == "true")
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            if (usuarioTemAcao(resposta, "RELATORIO_SUPRIMENTOS_NECESSIDADE_COMPRA")||usuarioTemAcao(resposta, "RELATORIO_PREVISAO_CONSUMO_MATERIA_PRIMA")) {
                setEditaRelatorios(true);
            }
            if (usuarioTemAcao(resposta, "LOTE_ATIVAR_DESATIVAR")) {
                setAtivaDesativaLote(true);
            }
        }).catch((erro) => {
            console.log(erro);
        });

        estoqueService.familias().then(lista => {
            setFamilias(lista);
        }).catch(err => {
            console.log(err);
        });
        estoqueService.origens().then(lista => {
            setOrigens(lista);
        }).catch(err => {
            console.log(err);
        });
        estoqueService.getProdutos().then(lista => {
            setProdutos(lista);
        }).catch(err => {
            console.log(err);
        });
        estoqueService.getDepositos().then(lista => {
            setDepositos(lista);
        }).catch(err => {
            console.log(err);
        });
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            setAjustaEstoque(usuarioLogadoService.usuarioTemAcao(resposta, "ESTOQUE_AJUSTAR"));
        }).catch((erro) => {
            console.log(erro);
        });
    }, [])

    useEffect(() => {
        filterContext.updateFilters(screen, filters);
        estoqueService.pesquisar(pageable, filters).then((response) => {
            console.log(response);
            setList(response.content);
            setTotalElements(response.totalElements);
        }).catch((error) => {
            console.log(error);
        });

    }, [pageable, filters]);

    function usuarioTemAcao(acoes: any, acao: any): boolean {
        return acoes.some((a: any) => a.sigla === acao);
    }

    function getRelatorioNecessidadeCompra() {
        estoqueService.relatorioNecessidadeCompra(filters).then((data) => {
            const file = new Blob([data], { type: 'application/pdf' });
            saveAs(file, `NecessidadeDeCompra.pdf`);
        }).catch((error) => {
            console.log(error);
        });
    }

    const filterField = (options: ColumnFilterElementTemplateOptions, list: any, label?: string) => {
        return <Dropdown value={options.value} options={list}
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel={label || "nome"} optionValue="codigo" placeholder="Qualquer" className="p-column-filter" />
    }

    const numberTemplate = (rowData: any, options: any) => {
        if (rowData[options.field] === null || rowData[options.field] === undefined) {
            return "";
        }
        return new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 6 }).format(rowData[options.field]);
    };

    const qtdMinimaTemplate = (rowData: any, options: any) => {
        if (rowData.produto.qtdMinima === null || rowData.produto.qtdMinima === undefined) {
            return "";
        }
        return new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 6 }).format(rowData.produto.qtdMinima);
    };

    const headerColumnGroup = (
        <ColumnGroup>
            <Row>
                <Column header="Origem" rowSpan={1} colSpan={esconderCodigos ? 1 : 2} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="origemProduto"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => filterField(options, origens)} />
                <Column header="Família" rowSpan={1} colSpan={esconderCodigos ? 1 : 2} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="familiaProduto"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => filterField(options, familias)} />
                <Column header="Produto" rowSpan={1} colSpan={esconderCodigos ? 1 : 2} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="produto"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => <ProdutoFilterTemplate options={options} opcoes={produtos} />} />
                <Column header="Depósito" rowSpan={1} colSpan={esconderCodigos ? 1 : 2} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="deposito"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => filterField(options, depositos)} />
                <Column header="Quantidade" rowSpan={2} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="quantidade"
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => decimalFilterTemplate(options)} sortable sortField='quantidade' />
                <Column header="Quantidade Emprestada" rowSpan={2} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="quantidadeEmprestada"
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => decimalFilterTemplate(options)} sortable sortField='quantidadeEmprestada' />
                <Column header="Qtd. Mínima" rowSpan={2} sortable sortField='produto.qtdMinima' />
                <Column header="Consumo Médio" rowSpan={2} sortable sortField='consumoMedio' />
            </Row>
            <Row>
                {!esconderCodigos ? <Column header="Código" sortable sortField='produto.familia.cdOrigem' /> : null}
                <Column header="Nome" sortable sortField='produto.familia.origemProduto.nome' />
                {!esconderCodigos ? <Column header="Código" sortable sortField='produto.cdFamilia' /> : null}
                <Column header="Nome" sortable sortField='produto.familia.nome' />
                {!esconderCodigos ? <Column header="Código" sortable sortField='produto.id.codigo' /> : null}
                <Column header="Nome" sortable sortField='produto.nome' filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="nomeProduto"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
                {!esconderCodigos ? <Column header="Código" sortable sortField='deposito.id.codigo' /> : null}
                <Column header="Nome" sortable sortField='deposito.nome' />
            </Row>
        </ColumnGroup>
    );

    const carregar = () => {
        filterContext.updateFilters(screen, filters);

        let estoqueSelecionadoAtual = estoqueSelecionado;
        let estoqueEncontrado: Estoque | null = null;

        estoqueService.pesquisar(pageable, filters).then((response) => {
            for (let i = 0; i < response.content.length; i++) {
                let estoque: Estoque = response.content[i];
                if (estoque.produto.codigo == estoqueSelecionadoAtual?.produto.codigo
                    && estoque.deposito.codigo == estoqueSelecionadoAtual?.deposito.codigo) {
                    estoqueEncontrado = estoque;
                }
            }

            setEstoqueSelecionado(estoqueEncontrado);
            setList(response.content);
            setTotalElements(response.totalElements);
        }).catch((error) => {
            console.log(error);
        });
    }

    const ativarDesativar = (estoqueLote: any) => {
        estoqueService.ativarDesativar(estoqueLote).then(() => {
            estoqueLote.ativo = !estoqueLote.ativo;
            setEstoqueSelecionado({ ...estoqueSelecionado as Estoque });
        }).catch((error) => {
            if (error.data && error.data.message) {
                msgAlerta("Alerta", error.data.message)
            } else {
                msgErro("Erro", "Ocorreu um erro ao tentar ativar/desativar o lote");
            }
            console.log(error);
        });
    }

    const clearFilter = () => {
        setFilters(defaultFilters || {});
    }

    const opcoesSplitButton = editaRelatorios ? [
        { label: "Previsão de consumo de matéria-prima", icon: "pi pi-chart-bar", command: () => setVisibleGerarRelatorioPrevisaoMateriaPrima(true) },
        { label: 'Editar relatório', command: () => { setVisibleEditarRelatorio(true) } }
    ] : [
        { label: "Previsão de consumo de matéria-prima", icon: "pi pi-chart-bar", command: () => setVisibleGerarRelatorioPrevisaoMateriaPrima(true) }
    ]

    return (
        <div>
            {visibleEditarRelatorio && <Dialog header="Editar Relatório" visible={visibleEditarRelatorio} style={{ width: '50vw' }} onHide={() => setVisibleEditarRelatorio(false)}>
                <ReportEdit titulo="Relatório de necessidade de compra" nomeAcao="RELATORIO_SUPRIMENTOS_NECESSIDADE_COMPRA" testarRelatorio={() => { }} />
                <ReportEdit titulo="Relatório de previsão de consumo de Matéria-prima" nomeAcao="RELATORIO_PREVISAO_CONSUMO_MATERIA_PRIMA" testarRelatorio={() => { }} />
                
            </Dialog>}
            {visibleGerarRelatorioPrevisaoMateriaPrima && <ModalGerarRelatorioPrevisaoMateriaPrima
                visible={visibleGerarRelatorioPrevisaoMateriaPrima}
                onHide={() => setVisibleGerarRelatorioPrevisaoMateriaPrima(false)}
            />}
            <Dialog header="Configurações" visible={visibleConfiguracoes} onHide={() => setVisibleConfiguracoes(false)}>
                <div style={{ display: "flex", padding: 20 }}>
                    <Checkbox checked={esconderCodigos} onChange={(e) => {
                        localStorage.setItem("esconderCodigos", e.checked as boolean ? "true" : "false");
                        setEsconderCodigos(e.checked as boolean);
                    }} style={{ marginRight: 8 }} />
                    <label>Esconder códigos</label>
                </div>
            </Dialog>
            <AjusteEstoqueModal
                visible={modalAjustar.visible}
                setVisible={(visible) => { setModalAjustar({ visible: visible, estoque: new Estoque, rowIndex: -1 }) }}
                estoque={modalAjustar.estoque}
                rowIndex={modalAjustar.rowIndex}
                onConfirm={() => {
                    setModalAjustar({ visible: false, estoque: new Estoque, rowIndex: -1 });
                    carregar();
                }}
            />
            <DataTable
                onSort={(e: DataTableStateEvent) => {
                    let sort = e.sortField ? e.sortField : "";
                    sort += e.sortOrder === 1 ? ",asc" : e.sortOrder === -1 ? ",desc" : "";
                    setPageable({ ...pageable, sort: sort });

                }}
                sortField={pageable.sort.split(",")[0]}
                sortOrder={pageable.sort.split(",")[1] === "asc" ? 1 : pageable.sort.split(",")[1] === "desc" ? -1 : 0}
                filters={filters}
                onFilter={(e) => setFilters(e.filters)}
                header={<div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                    <div></div>
                    <span style={{ textAlign: 'center', width: "100%", alignSelf: "center", position: 'relative' }}>Estoque</span>
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button type="button" icon="pi pi-cog" onClick={() => setVisibleConfiguracoes(true)} style={{ marginRight: 8 }} />
                        <SplitButton
                            onClick={() => getRelatorioNecessidadeCompra()}
                            label="Relat. Necessidade de compra" style={{ width: 300, marginRight: 8 }}
                            model={opcoesSplitButton}
                        />

                        <Button type="button" icon="pi pi-filter-slash" label="Limpar" outlined onClick={clearFilter} style={{ marginRight: 8 }} />

                    </div>
                </div>}
                value={list}
                scrollable scrollHeight="calc(100vh - 300px)"
                headerColumnGroup={headerColumnGroup}
                emptyMessage="Nenhum registro encontrado"
                first={pageable.first} rows={10} lazy
                onPage={(event) => { setPageable({ ...pageable, page: event.page !== undefined ? event.page : 0, first: event.first }) }}
                paginator={true} totalRecords={totalElements}
                selection={estoqueSelecionado as BaseModel} selectionMode="single" onSelectionChange={(e) => setEstoqueSelecionado(e.value as Estoque)}
            >
                {!esconderCodigos ? <Column field="produto.familiaProduto.origemProduto.codigo" style={{ minWidth: "75px" }}></Column> : null}
                <Column field="produto.familiaProduto.origemProduto.nome" style={{ minWidth: "175px" }}></Column>
                {!esconderCodigos ? <Column field="produto.familiaProduto.codigo" style={{ minWidth: "75px" }}></Column> : null}
                <Column field="produto.familiaProduto.nome" style={{ minWidth: "175px" }}></Column>
                {!esconderCodigos ? <Column field="produto.codigo" header="Código"></Column> : null}
                <Column field="produto.nome" header="Produto"></Column>
                {!esconderCodigos ? <Column field="deposito.codigo" header="Código Depósito"></Column> : null}
                <Column field="deposito.nome" header="Depósito"></Column>
                <Column field="quantidade" header="Quantidade" bodyClassName={(rowData, options) => {
                    return rowData.produto.qtdMinima > rowData.quantidade ? "cell-danger" : ""
                }} style={{ minWidth: "115px" }} body={numberTemplate}></Column>
                <Column field="quantidadeEmprestada" header="Quantidade Emprestada"
                    style={{ minWidth: "115px" }} body={numberTemplate}></Column>
                <Column field="produto.qtdMinima" header="Qtd. Mínima" style={{ minWidth: "115px" }} body={qtdMinimaTemplate}></Column>
                <Column field="consumoMedio" header="Consumo Médio" style={{ minWidth: "115px" }} body={numberTemplate}></Column>
            </DataTable>

            <DataTable
                header={<div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                    <span style={{ textAlign: 'center', width: "100%", alignSelf: "center", position: 'relative' }}>Lote</span>
                </div>}
                emptyMessage="Nenhum registro encontrado"
                value={estoqueSelecionado?.lotes} style={{ marginTop: 20 }}
            >
                <Column field="lote" header="Lote"></Column>
                <Column field="ativo" header="Ativo" body={(rowData) => <Checkbox checked={rowData.ativo} readOnly={!ativaDesativaLote} onChange={(e) => ativarDesativar(rowData)} />}></Column>
                <Column field="validade" header="Validade" body={(rowData) => converterData(rowData.validade)}></Column>
                <Column field="quantidade" header="Quantidade" body={numberTemplate}></Column>
                <Column field="quantidadeEmprestada" header="Quantidade Emprestada" body={numberTemplate}></Column>
                {ajustaEstoque ? <Column
                    body={(rowData, rowIndex) => (
                        <div>
                            <Button label="Ajustar" onClick={() => {
                                setModalAjustar({ visible: true, estoque: estoqueSelecionado, rowIndex: rowIndex.rowIndex })
                            }} style={{ marginLeft: 8 }} />
                        </div>
                    )}
                /> : null}
            </DataTable>
        </div>
    );
};

export default EstoqueConsulta;